import { HttpClient } from "@angular/common/http"
import { inject, Injectable } from "@angular/core"
import { HospitalDocMasterCreateBulkRequestDTO, HospitalDocMasterCreateRequestDTO, HospitalDocMasterDeleteRequestDTO, HospitalDocMasterDTO, HospitalDocMasterList, HospitalDocMasterReadByIdRequestDTO, HospitalDocMasterReadByMasterIdRequestDTO, HospitalDocMasterUpdateRequestDTO } from "./hospital-document.interface"
import { Observable } from "rxjs"
import { HospitalDocMaster_Create, HospitalDocMaster_CreateBulk, HospitalDocMaster_Delete, HospitalDocMaster_ExternalCreateBulk, HospitalDocMaster_ExternalReadByMasterId, HospitalDocMaster_ReadAll, HospitalDocMaster_ReadById, HospitalDocMaster_ReadByMasterId, HospitalDocMaster_Update } from "src/app/GlobalVariable/Hospital.GlobalVariable"

@Injectable({
  providedIn: 'root'
})
export class HospitalDocMasterService {

  constructor() { }
    http = inject(HttpClient);
  
    HospitalDocMaster_Create(data: HospitalDocMasterCreateRequestDTO): Observable<HospitalDocMasterDTO> {
      return this.http.post<HospitalDocMasterDTO>(HospitalDocMaster_Create, data)
    };
  
    HospitalDocMaster_Update(data: HospitalDocMasterUpdateRequestDTO): Observable<HospitalDocMasterDTO> {
      return this.http.post<HospitalDocMasterDTO>(HospitalDocMaster_Update, data)
    };
  
    HospitalDocMaster_ReadAll(): Observable<HospitalDocMasterList> {
      return this.http.get<HospitalDocMasterList>(HospitalDocMaster_ReadAll)
    };

    HospitalDocMaster_Delete(data: HospitalDocMasterDeleteRequestDTO): Observable<void> {
      return this.http.post<void>(HospitalDocMaster_Delete, data)
    };
  
    HospitalDocMaster_ReadById(data: HospitalDocMasterReadByIdRequestDTO): Observable<HospitalDocMasterDTO> {
      return this.http.post<HospitalDocMasterDTO>(HospitalDocMaster_ReadById, data)
    };
  
    HospitalDocMaster_ReadByMasterId(data: HospitalDocMasterReadByMasterIdRequestDTO): Observable<HospitalDocMasterList> {
      return this.http.post<HospitalDocMasterList>(HospitalDocMaster_ReadByMasterId, data)
    };

    HospitalDocMaster_ExternalReadByMasterId(data: HospitalDocMasterReadByMasterIdRequestDTO): Observable<HospitalDocMasterList> {
      return this.http.post<HospitalDocMasterList>(HospitalDocMaster_ExternalReadByMasterId, data)
    };

    HospitalDocMaster_CreateBulk(data: HospitalDocMasterCreateBulkRequestDTO): Observable<HospitalDocMasterList> {
      return this.http.post<HospitalDocMasterList>(HospitalDocMaster_CreateBulk, data);
    }

    HospitalDocMaster_ExternalCreateBulk(data: HospitalDocMasterCreateBulkRequestDTO): Observable<HospitalDocMasterList> {
      return this.http.post<HospitalDocMasterList>(HospitalDocMaster_ExternalCreateBulk, data);
    }
}